// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K1cj","largestCol":"styles_largestCol__1YYkj","smallestCol":"styles_smallestCol__1c22I"};